import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	none: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tooltipGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	none: {
		id: 'issue-create-commons.multi-versions-field.none',
		defaultMessage: 'None',
		description: 'When there are no release versions',
	},
	tooltip: {
		id: 'issue-create-commons.multi-versions-field.tooltip',
		defaultMessage: "We couldn't find any versions for this project",
		description: 'when the version field is disabled',
	},
	tooltipGalaxia: {
		id: 'issue-create-commons.multi-versions-field.tooltip-galaxia',
		defaultMessage: "We couldn't find any versions for this space",
		description: 'when the version field is disabled',
	},
});
export default messages;
